<template>
<main-sidebar :name="name" :title="$t('add_new_comment')">
  <div class="p-4">
    <vs-row>
      <vs-col vs-w="12" class="mb-3">
        <vs-textarea v-model="comment"/>
      </vs-col>
      <vs-col vs-w="12" class="mb-3">
        <upload-file v-model="files" list btnType="filled" btnColor="success" class="w-full m-2" :btnText="$t('upload_file')" accept="image/jpeg,image/png,application/pdf" />
      </vs-col>
      <vs-col vs-w="12" class="mb-3">
        <vs-checkbox v-model="packingSlip">
          {{ $t('is_this_file_a_packing_slip') }}
        </vs-checkbox>
      </vs-col>
    </vs-row>
  </div>

  <div class="mx-4" slot="footer">
    <vs-button color="primary" type="filled" class="mr-6" @click="submit" :disabled="disabledSubmit">
      {{ $t('save') | capitalize }}
    </vs-button>
    <vs-button color="primary" type="border" @click="close">
      {{ $t('cancel') | capitalize }}
    </vs-button>
  </div>
</main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate'
import UploadFile from '@/views/components/UploadFile.vue'
import entry from '@/http/requests/entry'
export default {
  components: {
    MainSidebar,
    UploadFile,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    disabledSubmit(){
      return ( this.packingSlip === true && this.files.length === 0 ) || this.comment === ''
    },
    isLoading() {
      return this.loading.submit
    },
  },
  data: () => ({
    name: 'entry-add-comment',
    comment: '',
    packingSlip: false,
    files: [],
    loading: {
      submit: false,
    },
  }),
  methods: {
    clear() {
      this.comment = ''
      this.packingSlip = false
      this.files = []
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.clear()
    },
    submit() {
      this.loading.submit = true
      let data = new FormData()
      data.append('entries_id', this.entry)
      data.append('body', this.comment)
      data.append('packingSlip', this.packingSlip)
      if(this.files.length > 0){
        data.append('file', this.files[0])
      }
      if(this.packingSlip === true){
        data.append('title', 'packing-slipt')
      }
      
      entry.addComment(data)
        .then((res)=> {
          this.$emit('add',res.data.item)
           this.loading.submit = false
          if(this.files.length > 0){
            this.$emit('reload')
          }
          this.close()
        })
        .catch(res => {
          this.displayErrors(res)
          this.loading.submit = false
        })
    },
  },
  mixins: [loading, validate],
  props: {
    entry: {
      type: String,
      required: true,
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
</style>
